<template>
  <div>
    <b-card title="Binary">
      <b-card-body>
        <table>
          <tr>
            <td class='input' colspan="2">
            <b-form-input class="conversion-input" v-model="binaryValue" :state="binaryValid" placeholder="Enter a binary value"/>
            </td>
          </tr>
          <tr>
            <td>Decimal</td>
            <td class='integer'>{{binaryToDecimalConversion}} 
              <b-icon icon="info-circle-fill" scale="1" variant="info" v-b-toggle.binary-to-decimal></b-icon>
              </td>
          </tr>
          <tr>
            <td>Hexadecimal</td>
            <td class='integer'>{{binaryToHexadecimalConversion}} 
              <b-icon icon="info-circle-fill" scale="1" variant="info" v-b-toggle.binary-to-hexadecimal></b-icon>
              </td>
          </tr>
        </table>
      </b-card-body>
    </b-card><p/>
    <b-card 
      title="Decimal">
      <b-card-body>
        <table>
          <tr>
            <td class='input' colspan="2">
            <b-form-input class="conversion-input" v-model="decimalValue" :state="decimalValid" placeholder="Enter a decimal value"/>
            </td>
          </tr>
          <tr>
            <td>Binary</td>
            <td class='integer'>{{decimalToBinaryConversion}} 
              <b-icon icon="info-circle-fill" scale="1" variant="info" v-b-toggle.decimal-to-binary></b-icon>
              </td>
          </tr>
          <tr>
            <td>Hexadecimal</td>
            <td class='integer'>{{decimalToHexadecimalConversion}} 
              <b-icon icon="info-circle-fill" scale="1" variant="info" v-b-toggle.decimal-to-hexadecimal></b-icon>
              </td>
          </tr>
        </table>
      </b-card-body>
    </b-card><p/>
    <b-card 
      title="Hexadecimal">
      <b-card-body>
        <table>
          <tr>
            <td class='input' colspan="2">
            <b-form-input class="conversion-input" v-model="hexadecimalValue" :state="hexadecimalValid" placeholder="Enter a hexadecimal value"/>
            </td>
          </tr>
          <tr>
            <td>Binary</td>
            <td class='integer'>{{hexadecimalToBinaryConversion}} 
              <b-icon icon="info-circle-fill" scale="1" variant="info" v-b-toggle.hexadecimal-to-binary></b-icon>
              </td>
          </tr>
          <tr>
            <td>Decimal</td>
            <td class='integer'>{{hexadecimalToDecimalConversion}} 
              <b-icon icon="info-circle-fill" scale="1" variant="info" v-b-toggle.hexadecimal-to-decimal></b-icon>
              </td>
          </tr>
        </table>
      </b-card-body>
    </b-card>
    <b-sidebar id="binary-to-decimal" title="Binary to Decimal" width="375px" right shadow backdrop backdrop-variant="white">
      <div class="px-3 py-2">
        <p>
          The decimal value is #{{this.binaryInt.toString()}}
        </p>
        <span v-html="binaryToDecimalDetails"/>
      </div>
    </b-sidebar>
    <b-sidebar id="binary-to-hexadecimal" title="Binary to Hexadecimal" width="375px" right shadow backdrop backdrop-variant="white">
      <div class="px-3 py-2">
        <p>
          The hexadecimal value is x{{this.binaryInt.toString(16).toUpperCase()}}
        </p>
      </div>
      <p align="center" v-html="binaryToHexadecimalDetails"/>
    </b-sidebar>
    <b-sidebar id="decimal-to-binary" title="Decimal to Binary" width="375px" right shadow backdrop backdrop-variant="white">
      <div class="px-3 py-2">
        <p>
          The binary value is {{this.decimalInt.toString(2)}}
          <b-table :items="decimalToBinaryDetails" :fields="decimalToBinaryFields"/>
        </p>
      </div>
    </b-sidebar>
    <b-sidebar id="decimal-to-hexadecimal" title="Decimal to Hexadecimal" width="375px" right shadow backdrop backdrop-variant="white">
      <div class="px-3 py-2">
        <p>
          The hexadecimal value is x{{this.decimalInt.toString(16).toUpperCase()}}
          <b-table :items="decimalToHexadecimalDetails" :fields="decimalToBinaryFields"/>
        </p>
      </div>
    </b-sidebar>
    <b-sidebar id="hexadecimal-to-binary" title="Hexadecimal to Binary" width="375px" right shadow backdrop backdrop-variant="white">
      <div class="px-3 py-2">
        <p>
          The binary value is {{this.hexadecimalInt.toString(2)}}
        </p>
        <p align="center" v-html="hexadecimalToBinaryDetails"/>
      </div>
    </b-sidebar>
    <b-sidebar id="hexadecimal-to-decimal" title="Hexadecimal to Decimal" width="375px" right shadow backdrop backdrop-variant="white">
      <div class="px-3 py-2">
        <p>
          The decimal value is #{{this.hexadecimalInt.toLocaleString()}}
        </p>
        <span v-html="hexadecimalToDecimalDetails"/>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {NumberFormats} from '@/util/constants'

export default {
  name: 'conversions',
  data () {
    return {
      binaryValue: '',
      decimalValue: '',
      hexadecimalValue: '',
      decimalToBinaryFields: [
        {
          key: 'dividend',
          tdClass: 'd-t-b-td'
        },
        {
          key: 'remainder',
          tdClass: 'd-t-b-r-td'
        }
      ],
      decimalToBinaryDetails: [],
      decimalToHexadecimalDetails: []
    }
  },
  methods: {
    decimalToBase (value, base) {
      var details = []
      while (value > 0) {
        var row = {dividend: value.toString() + ' / ' + base, remainder: (value % base).toString(base).toUpperCase()}
        details.push(row)
        value = Math.floor(value / base)
      }
      return details
    },
    computedDecimalToBinaryDetails () {
      if (!this.decimalValid) {
        this.decimalToBinaryDetails = []
        return
      }

      this.decimalToBinaryDetails = this.decimalToBase(this.decimalInt, 2)
    },
    computedDecimalToHexadecimalDetails () {
      if (!this.decimalValid) {
        this.decimalToHexadecimalDetails = []
      }

      this.decimalToHexadecimalDetails = this.decimalToBase(this.decimalInt, 16)
    },
    computedHexadecimalToBinaryTable (binary) {
      let binaryLength = binary.length
      let bits = ((binaryLength % 4) !== 0 ? '0'.repeat(4 - (binaryLength % 4)) : '') + binary
      let details = '<table><tr>'
      for (let i = 0; i < Math.floor(bits.length / 4); i++) {
        details += '<td class="hex">' + parseInt(bits.substring(i * 4, (i * 4) + 4), 2).toString(16).toUpperCase() + '</td>'
      }
      details += '</tr>'
      for (let i = 0; i < Math.floor(bits.length / 4); i++) {
        details += '<td class="bin">' + bits.substring(i * 4, (i * 4) + 4) + '</td>'
      }
      return details + '</tr></table>'
    },
    computeBaseToDecimalDetails (base, baseValueStr, decimalInt) {
      let details = ''
      let baseValueLength = baseValueStr.length
      for (let exponent = baseValueLength; exponent > 0; exponent--) {
        details += '<b>' + baseValueStr[baseValueLength - exponent] + '</b> &times; ' + base + '<sup>' + (exponent - 1) + '</sup>'
        if (exponent > 1) {
          details += ' + '
        }
      }
      details += ' = #' + decimalInt.toLocaleString()
      return details
    }
  },
  computed: {
    parseableBinary () {
      return this.binaryValue.substring(1)
    },
    parseableDecimal () {
      return this.decimalValue.substring(1)
    },
    parseableHexadecimal () {
      return this.hexadecimalValue.substring(1)
    },
    binaryInt () {
      return parseInt(this.parseableBinary, 2)
    },
    decimalInt () {
      return parseInt(this.parseableDecimal, 10)
    },
    hexadecimalInt () {
      return parseInt(this.parseableHexadecimal, 16)
    },
    binaryValid () {
      return this.binaryValue.length < 1 ? null : NumberFormats.BINARY_RE.test(this.binaryValue)
    },
    binaryToDecimalConversion () {
      this.computedDecimalToBinaryDetails()
      return this.binaryValid ? '#' + this.binaryInt.toString() : ''
    },
    binaryToHexadecimalConversion () {
      this.computedDecimalToHexadecimalDetails()
      return this.binaryValid ? 'x' + this.binaryInt.toString(16).toUpperCase() : ''
    },
    decimalValid () {
      return this.decimalValue.length < 1 ? null : NumberFormats.DECIMAL_RE.test(this.decimalValue)
    },
    decimalToBinaryConversion () {
      return this.decimalValid ? 'b' + this.decimalInt.toString(2) : ''
    },
    decimalToHexadecimalConversion () {
      return this.decimalValid ? 'x' + this.decimalInt.toString(16).toUpperCase() : ''
    },
    hexadecimalValid () {
      return this.hexadecimalValue.length < 1 ? null : NumberFormats.HEXADECIMAL_RE.test(this.hexadecimalValue)
    },
    hexadecimalToBinaryConversion () {
      return this.hexadecimalValid ? 'b' + this.hexadecimalInt.toString(2) : ''
    },
    hexadecimalToDecimalConversion () {
      return this.hexadecimalValid ? '#' + this.hexadecimalInt.toString() : ''
    },
    binaryToDecimalDetails () {
      return this.computeBaseToDecimalDetails(2, this.parseableBinary, this.binaryInt)
    },
    binaryToHexadecimalDetails () {
      return this.computedHexadecimalToBinaryTable(this.parseableBinary)
    },
    hexadecimalToBinaryDetails () {
      return this.computedHexadecimalToBinaryTable(this.hexadecimalInt.toString(2))
    },
    hexadecimalToDecimalDetails () {
      return this.computeBaseToDecimalDetails(16, this.parseableHexadecimal, this.hexadecimalInt)
    }
  }
}
</script>

<style>
.integer {
  font-family: monospace;
  text-align: right;
}

.input {
  padding-bottom: 1em;
}

.conversion-input {
  width: 350px;
}

.header {
  color: #000;
}

.d-t-b-td {
  text-align: right;
}

.d-t-b-r-td {
  text-align: center;
}

.bin {
  padding-right: 7px;
}

.hex {
  text-align: center;
}

</style>


// WEBPACK FOOTER //
// src/components/conversions.vue